import sdl from '@jds/react-generated-sdl/JDSSelector';
import type { JDSSelectorProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, SelectorProps } from '../logic';

const Component = (props: SelectorProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    stretch = false,
    kind = 'undefined',
    wrap = 'undefined',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { stretch, kind, wrap, ...rest },
    'JDSSelector',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Selectors = withLogic(Component) as React.FC<SelectorProps> & {
  slotName?: string;
};

Selectors.displayName = 'Selectors';
Selectors.slotName = 'jds_selector';

export { Selectors, type JDSSelectorProps };
